import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          {/* Logo + tagline */}
          <div className="max-w-xs">
            <img
              src="/jambitionlogo.png"
              alt="Jambition"
              className="h-9 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Enterprise-Grade AI Automation.<br />Built for Growing Businesses.
            </p>
          </div>

          {/* Company links */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-semibold tracking-widest uppercase text-gray-500 mb-1">
              Company
            </p>
            <Link
              to="/services"
              className="text-sm text-gray-300 hover:text-amber-400 transition-colors"
            >
              Services
            </Link>
            <Link
              to="/about"
              className="text-sm text-gray-300 hover:text-amber-400 transition-colors"
            >
              About
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-gray-300 hover:text-amber-400 transition-colors"
            >
              Privacy Policy
            </Link>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-semibold tracking-widest uppercase text-gray-500 mb-1">
              Contact
            </p>
            <a
              href="mailto:josh@jambition.io"
              className="text-sm text-gray-300 hover:text-amber-400 transition-colors"
            >
              josh@jambition.io
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-8">
          <p className="text-xs text-gray-500">
            © 2026 Jambition. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
